<script lang="ts">
	import { getContext } from "svelte";
	import { twJoin } from "tailwind-merge";
	import { SocialLinkSchema, type SocialLink } from "#gen/bundles/v1/contact_pb.js";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import Icon from "#lib/components/Icon.svelte";
	import TokenizedText from "#lib/components/TokenizedText.svelte";
	import type { ComponentProps } from "#lib/components/page/ComponentProps.js";
	import { socialIcons } from "#lib/iconProvider.js";
	import { fromJson, type JsonObject } from "#lib/protobuf-compat.js";
	import { booleanValue, listValue, stringValue, structValue } from "#lib/struct.js";
	import type { TokenProvider } from "#lib/tokenProvider.js";
	import Button from "#lib/ui/Button/index.js";
	import type { Writable } from "svelte/store";

	const tokenProvider: Writable<TokenProvider> = getContext("tokenProvider");

	const { id, style, page, readOnly = false, mode }: ComponentProps = $props();

	const config = $derived(structValue($page.config, id));
	const disabled = $derived(booleanValue(config, "disabled"));

	function getSocialLinks(config: JsonObject | undefined): SocialLink[] {
		const list = listValue(config, "links");
		return list?.map(value => fromJson(SocialLinkSchema, value, { ignoreUnknownFields: true })) ?? [];
	}
</script>

<div class={twJoin("flex gap-1", stringValue(config, "alignment") ?? "justify-start")} {style}>
	{#if mode === Mode.EDITING && $tokenProvider?.hasSubstitutionToken(stringValue(config, "links") ?? "")}
		<TokenizedText provider={$tokenProvider} text={stringValue(config, "links") ?? ""} {mode} />
	{:else}
		{#each getSocialLinks(config) as link, index (`${link.type}:${index}`)}
			{@const icon = socialIcons.get(link.type)}
			<Button data-action-name="social-link" color="none" class="p-1 disabled:pointer-events-none disabled:cursor-pointer disabled:opacity-100" on:click={() => window.open(link.id)} disabled={readOnly || disabled}>
				<Icon iconSet={icon?.iconSet} name={icon?.icon} class="h-6 w-6" />
			</Button>
		{/each}
	{/if}
</div>
